module.exports = __webpack_public_path__ + "img/video-doc.5353de11.jpg";